/**
 * Базовый абстрактный класс для реализации паттерна Singleton
 * 
 * Использование:
 * ```typescript
 * class MyClass extends SingletonClass {
 *   private static _instance: MyClass;
 *   
 *   static getInstance(): MyClass {
 *     if (!MyClass._instance) {
 *       MyClass._instance = new MyClass();
 *     }
 *     return MyClass._instance;
 *   }
 * }
 * ```
 * 
 * Или используйте вспомогательный метод:
 * ```typescript
 * class MyClass extends SingletonClass {
 *   static getInstance(): MyClass {
 *     return this.getOrCreateInstance(MyClass);
 *   }
 * }
 * ```
 */
export abstract class SingletonClass {
    /**
     * Вспомогательный метод для создания единственного экземпляра класса
     * @param Class Конструктор класса
     * @param instanceHolder Объект для хранения экземпляра (передается из дочернего класса)
     * @returns Единственный экземпляр класса
     */
    
    protected static getOrCreateInstance<T>(
        Class: new () => T,
        instanceHolder: { _instance?: T }
    ): T {
        if (!instanceHolder._instance) {
            instanceHolder._instance = new Class();
        }
        return instanceHolder._instance;
    }
}
